import type { Dictionnaire } from '../type';

export const composants: Dictionnaire['composants'] = {
  champ: {
    masquer: 'إخفاء كلمة المرور',
    afficher: 'إظهار كلمة المرور',
    effacer: 'مسح البحث',
  },
  badge: {
    officiel: 'حساب Sirocco الرسمي',
    verifie: 'حساب موثّق',
  },
  bulleAppel: {
    revenir: (nom: string) => `العودة إلى المكالمة مع ${nom}`,
  },
  etat: {
    annule: 'أُلغيت: عدد المشاركين غير كافٍ',
    confirme: 'مؤكّدة',
    spontanee: 'عفوية',
    enLigne: 'عبر الإنترنت',
    seuil: (n: number) => `(${n} على الأقل)`,
  },
  vocal: {
    pause: 'إيقاف مؤقت',
    ecouter: 'تشغيل الرسالة الصوتية',
    apercu: (duree: string) => `رسالة صوتية، ${duree}`,
  },
  onglets: {
    messages: 'الرسائل',
    evenements: 'الفعاليات',
    feed: 'الأخبار',
    lieux: 'الأماكن',
    profil: 'حسابي',
    annuaire: 'الدليل',
  },
  barre: {
    navigation: 'التنقّل الرئيسي',
    aRegarder: (onglet: string, n: number) => `${onglet} · ${n} للاطلاع`,
  },
  photo: {
    pasOuverte: 'تعذّر فتح هذه الصورة',
    pasPreparee: 'تعذّر تجهيز هذه الصورة',
    recadrer: 'قصّ الصورة',
    annuler: 'إلغاء',
    choisir: 'اختيار',
  },
  fichier: {
    pasAjoute: 'تعذّرت إضافة هذا الملف',
  },
  scanner: {
    sansCamera: 'لا يستطيع Sirocco الوصول إلى الكاميرا. يمكنك تسجيل الحضور يدويًا.',
  },
  partage: {
    pasParti: 'لم تتمّ المشاركة.',
    lienCopie: 'تم نسخ الرابط.',
    impossible: 'المشاركة غير متاحة في هذا المتصفح.',
    copieImpossible: 'النسخ غير متاح في هذا المتصفح.',
    titre: 'مشاركة',
    chercher: 'ابحث عن صديق أو مجموعة',
    unInstant: 'لحظة…',
    sansCible: 'أضف أصدقاء أو أنشئ مجموعة لتشارك دون مغادرة Sirocco.',
    aucun: 'لا يوجد اسم مطابق.',
    envoi: 'جارٍ الإرسال…',
    ailleurs: 'مشاركة في مكان آخر',
    copier: 'نسخ الرابط',
    envoyeA: (nom: string) => `أُرسلت إلى ${nom}.`,
  },
  image: {
    pasUneImage: 'هذا الملف ليس صورة',
    navigateur: 'متصفحك لا يستطيع تجهيز هذه الصورة',
    tropLourde: 'هذه الصورة كبيرة جدًا، جرّب صورة أخرى',
    pasOuverte: 'تعذّر فتح هذه الصورة',
  },
  video: {
    tropLourde: (mo: number) =>
      `هذا الفيديو كبير جدًا: ${mo} ميغابايت، والحد الأقصى 25. صوّره بجودة عادية بدلًا من 4K.`,
    tropLongue: (secondes: number) => `خمس عشرة ثانية كحد أقصى. هذا الفيديو مدته ${secondes} ثانية.`,
  },
  voix: {
    appareil: 'جهازك لا يستطيع تسجيل الرسائل الصوتية',
    micro: 'لا يستطيع Sirocco الوصول إلى الميكروفون. اسمح له بذلك من الإعدادات.',
    interrompu: 'توقّف التسجيل',
    tropCourt: 'قصير جدًا. أبقِ إصبعك مضغوطًا مدة أطول قليلًا.',
    tropLong: 'الرسالة الصوتية أطول من أن تُرسل',
    illisible: 'تسجيل غير مقروء',
  },
  itineraire: {
    plans: 'الخرائط',
  },
  billet: {
    monBillet: 'تذكرتي',
  },
  emojis: {
    smileys: 'وجوه',
    gestes: 'إيماءات',
    coeurs: 'قلوب',
    animaux: 'حيوانات',
    nourriture: 'طعام',
    sports: 'رياضة',
    voyages: 'سفر',
    objets: 'أشياء',
    symboles: 'رموز',
  },
};
